import React from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCapacityEditHistoryConsumer } from "../../../store/ConsumerCapacity/action";
import { getCapacityEditHistoryGenerator } from "../../../store/Capacity/actions";
import NodataFound from "../../../commons/Toast/noDataFound";

const CapacityEditHistory = ({
  show,
  closeCapacityEditHistoryModal,
  bidItem,
  setIsLoading,
}) => {
  const dispatch = useDispatch();
  const role = useSelector((state) => state?.sessionState?.role);
  const getCapacityEditHistory = (state) => {
    return role === "GENERATOR"
      ? state?.consumerCapacityReducer?.conCapacityEditHistory
      : state?.capacityReducer?.genCapacityEditHistory;
  };

  const rows = useSelector((state) => getCapacityEditHistory(state));
  useEffect(() => {
    if (role === "GENERATOR") {
      getCapacityEditHistoryConsumer(bidItem?.id, setIsLoading)(dispatch);
    } else {
      getCapacityEditHistoryGenerator(bidItem?.id, setIsLoading)(dispatch);
    }
  }, []);

  return (
    <div>
      {rows?.length > 0 ? (
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="a dense table">
            <TableHead className="table-header">
              <TableRow>
                <TableCell align="center">Date</TableCell>
                <TableCell align="center">Time Slot</TableCell>
                <TableCell align="center">Energy Rate(₹ per unit)</TableCell>
                <TableCell align="center">Quantity (MW)</TableCell>
                <TableCell align="center">Edited on</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows?.map((row, i) => (
                <TableRow
                  key={row.i}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell align="center">
                    {row.dateStartAt} - {row.dateEndAt}
                  </TableCell>
                  <TableCell align="center">
                    {row.slotStartAt} -{" "}
                    {row.slotEndAt && row.slotEndAt === "23:59"
                      ? "24:00"
                      : row.slotEndAt}
                  </TableCell>
                  <TableCell align="center">
                    {row?.energyRateStr
                      ? row?.energyRateStr
                      : role === "GENERATOR"
                      ? row.landingCost
                      : row.sellingCost}
                  </TableCell>
                  <TableCell align="center">
                    {role === "GENERATOR" ? row.purchaseEnergy : row.sellEnergy}
                  </TableCell>
                  <TableCell align="center">{row.updatedAt}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <NodataFound />
      )}
    </div>
  );
};

export default CapacityEditHistory;
